import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CoursePlanType } from "../../../types/CoursePlan";

const initialState: CoursePlanType = {
    id: '',
    docBase64: '',
    extension: '',
    idAcademicYear: '',
    idCourse: '',
    status: false,
    idDepartament: '',
    idFaculty: ''
}

export const coursePlanSlice = createSlice({
    name: 'coursePlanForm',
    initialState,
    reducers: {
        setUpdateCoursePlanData: (state, action: PayloadAction<CoursePlanType>) => {
            return { ...state, ...action.payload };
        },
        resetUpdateCoursePlanData: (state) => {
            return initialState;
        }
    }
});
export const {setUpdateCoursePlanData, resetUpdateCoursePlanData } = coursePlanSlice.actions;
export default coursePlanSlice.reducer;